<template>
  <div class="container mt-lg-5 position-relative">
    <div class="d-flex flex-row align-items-center justify-content-start gap-3">
      <h2>fidu</h2>
      <a href="https://www.canva.com/design/DAGsffPYOkY/sflVa7AgfVxF2uG6puY_cg/edit?utm_content=DAGsffPYOkY&utm_campaign=designshare&utm_medium=link2&utm_source=sharebutton"
        class="d-flex flex-row text-decoration-none align-items-center justify-content-start mt-1" target="_blank">
        <p class="m-0 fs-6 texto-secundario">{{ $t('instructivo') }}</p>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" class="stroke-secundario" xmlns="http://www.w3.org/2000/svg">
          <path id="Vector" d="M10.0002 5H8.2002C7.08009 5 6.51962 5 6.0918 5.21799C5.71547 5.40973 5.40973 5.71547 5.21799 6.0918C5 6.51962 5 7.08009 5 8.2002V15.8002C5 16.9203 5 17.4801 5.21799 17.9079C5.40973 18.2842 5.71547 18.5905 6.0918 18.7822C6.5192 19 7.07899 19 8.19691 19H15.8031C16.921 19 17.48 19 17.9074 18.7822C18.2837 18.5905 18.5905 18.2839 18.7822 17.9076C19 17.4802 19 16.921 19 15.8031V14M20 9V4M20 4H15M20 4L13 11" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </a>
    </div>
    <div class="d-flex flex-wrap justify-content-start align-items-center overflow-hidden gap-3 fondo-terciario rounded-3 px-2 sombra-sm">
        <button v-if="hasVerAlumnosFidu"
            class="btn-menu-2 fs-6 d-inline-flex gap-2 py-2 texto-secundario"
            :class="{'active-btn': MenuVisible == 1}"
            @click="MenuVisible = 1"
        >
            {{ $t('usuarios') }}
        </button>
        <button v-if="hasSubirDocFidu"
            class="btn-menu-2 fs-6 d-inline-flex gap-2 py-2 texto-secundario"
            :class="{'active-btn': MenuVisible == 2}"
            @click="MenuVisible = 2"
        >
            <span>{{ $t('subidas') }}</span>
        </button>
        <div v-if="loadingMenu" class="loading-spinner h-100 d-inline-flex align-items-center justify-content-center">
            <img src="@/assets/LOADING.gif" style="width: 20px;" alt="Cargando..." />
        </div>
    </div>

    <div v-if="MenuVisible == 1 && hasVerAlumnosFidu" class="d-flex flex-column gap-2">
        <UsuariosFidu/>
    </div>
    <div v-if="MenuVisible == 2 && hasSubirDocFidu" class="d-flex flex-column gap-2">
        <SubidasFidu/>
    </div>

  </div>
</template>

<script>
  import { ref, onMounted, computed, watch } from 'vue';
  import {useStore} from "vuex";
  import {useRouter} from "vue-router";
  import { useI18n } from 'vue-i18n';
  import SubidasFidu from './SubidasFidu.vue';
  import UsuariosFidu from './UsuariosFidu.vue';

export default {
  name: 'PersonasPage',
   components: {
     SubidasFidu,
     UsuariosFidu
   },
  setup() {
    const { t } = useI18n();
    const router = useRouter();
    const store = useStore();
    const user = computed(() => store.state.user);
    const MenuVisible = ref(1);
    var hasVerAlumnosFidu = ref(false);
    var hasSubirDocFidu = ref(false);


    const checkAuth = async  () => {
      if (user.value && user.value.personasPermisos) {
        var categoriaAComprobar = 'VerAlumnosFidu'
        if (user.value.personasPermisos.some(persPermiso => persPermiso.idPermisoNavigation?.subCategoria === categoriaAComprobar) || 
          user.value.personasRoles.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.subCategoria === categoriaAComprobar))){
          hasVerAlumnosFidu.value = true;
        }
        
        var permisoAComprobar = 'SubirDocFidu'
        if (user.value.personasPermisos.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
          user.value.personasRoles.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar))){
          hasSubirDocFidu.value = true;
        }

        if (hasVerAlumnosFidu.value || hasSubirDocFidu.value){
          console.log("Tiene Permiso")
        }
        else{
          console.log('Usuario no tiene permiso a acceder.');
          await router.push('/');
        }
      }
    };

    onMounted(() => {
      const lastUpdate = localStorage.getItem("lastUpdate");
      const today = new Date().toISOString().split("T")[0]; // Obtiene solo la fecha (YYYY-MM-DD)

      if (lastUpdate !== today) {
        localStorage.setItem("lastUpdate", today);
        window.location.reload(); // Recarga la página solo si no se ha recargado hoy
      }
      // Load saved menu preference
      const savedMenu = localStorage.getItem('fiduPageMenuVisible');
      if (savedMenu) {
        MenuVisible.value = parseInt(savedMenu);
      }
      checkAuth();
    });

    // Watch for changes in MenuVisible and save to localStorage
    watch(MenuVisible, (newVal) => {
      localStorage.setItem('fiduPageMenuVisible', newVal.toString());
    });

    return {
      checkAuth,
      t,
      MenuVisible,
      hasVerAlumnosFidu,
      hasSubirDocFidu,
    };
  },
};
</script>

<style>
.permissions-list {
  margin-top: 10px;
}

.roles-column {
  width: 250px; /* Fixed width for roles column */
}
</style>

